import { Notice } from "../Common/Notice";
import { useTitle } from "../Common/UseTitle";

export default function NotFound() {
  useTitle("Not found");
  return <Notice title="Oops, page not found." />;
}
